import { httpService } from "../http"
import { GetRideInfoResponse, GetRideRecordsResponse, SubmitRideInfoRequestParams, SubmitRideInfoResponse } from "./bike_ride";

const NEW_JAVA_SERVER = process.env.REACT_APP_MIO_SASS;

export const beginCycling = (): Promise<GetRideInfoResponse> => {
  return httpService.post("/platform/cycling/begin", {}, {
    baseURL: NEW_JAVA_SERVER, headers: {
      channel: "mio-app"
    }
  });
}

export const getRideInfo = (): Promise<GetRideInfoResponse> => {
  return httpService.get("/platform/cycling", {}, {
    baseURL: NEW_JAVA_SERVER, headers: {
      channel: "mio-app"
    }
  });
}

export const submitRideInfo = (params: SubmitRideInfoRequestParams): Promise<SubmitRideInfoResponse> => {
  return httpService.post("/platform/cycling", params, {
    baseURL: NEW_JAVA_SERVER, headers: {
      channel: "mio-app"
    }
  });
}

export const getRideRecords = (): Promise<GetRideRecordsResponse> => {
  return httpService.get("/platform/cycling/statistics", {}, {
    baseURL: NEW_JAVA_SERVER, headers: {
      channel: "mio-app"
    }
  });
}
